(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/*global $, jQuery, alert, console*/

"use strict";

$(document).ready(function () {
    let allHours = 0;


    controlEmptyCheckboxes();
    countHours();
    agendaTabControl();
    agendaToolsTabControl();
    stepControl();

    $('.topics-checkbox').on('change', function () {
        countHours();
    });

    $('.main-topic-checkbox').on('change', function (e) {
        if($(this).is('required')) return;

        if ($(this).is(':checked')) {
            $(this).closest('.s-agenda-steps__topic-item').find('.topics-checkbox').each(function () {
                if($(this).attr('required')) return;

                if (!$(this).is(':checked')) {
                    $(this).trigger('click');
                }
            });
        } else {
            $(this).closest('.s-agenda-steps__topic-item').find('.topics-checkbox').each(function () {
                if($(this).attr('required')) return;

                if ($(this).is(':checked')) {
                    $(this).trigger('click');
                }
            });
        }
        countHours();
    });

    $('.tool-checkbox').on('click', function () {
       if ($(this).is(':checked')) {
           $(this).closest('.s-agenda-steps__tabs-result').addClass('active');
       } else {
           $(this).closest('.s-agenda-steps__tabs-result').removeClass('active');
       }
    });

    $('#agendaFormSubmitBtn').on('click', function (e) {
        e.preventDefault();
        $('#agendaStepForm').submit();
    });





    function agendaTabControl() {
        $('.s-agenda-steps__tab').on('click', function () {
            if (validHours()) {
                let curId = $(this).attr('data-href').substr(1);
                $('.s-agenda-steps__tab').each(function () {
                    $(this).removeClass('active');
                });
                $(this).addClass('active');

                $('.s-agenda-steps__result').each(function () {
                    $(this).removeClass('active');
                    if ($(this).attr('id') == curId) {
                        $(this).addClass('active');
                    }
                });
                $('html, body').animate({
                    scrollTop: $('#agendaStepsContent').offset().top - 90
                }, 500);
            }
        })
    }
    
    
    function validHours() {
        if ($('#agendaStepsContent').hasClass('check-hours-validation')) {
            if (allHours < 16) {
                $('.s-agenda__validation-wrap').addClass('error-hours');
                return false
            } else {
                $('.s-agenda__validation-wrap').removeClass('error-hours');
                return true
            }
        } else {
            return true
        }

    }


    function stepControl() {
        $('.btn__next-step').on('click', function (e) {
            e.preventDefault();
            if (validHours()) {
                $('.s-agenda-steps__tab.active').removeClass('active').next('.s-agenda-steps__tab').addClass('active');
                $('.s-agenda-steps__result.active').removeClass('active').next('.s-agenda-steps__result').addClass('active');
                $('html, body').animate({
                    scrollTop: $('#agendaStepsContent').offset().top - 90
                }, 500);
            }
        });
        $('.btn__prev-step').on('click', function (e) {
            e.preventDefault();
            if (validHours()) {
                $('.s-agenda-steps__tab.active').removeClass('active').prev('.s-agenda-steps__tab').addClass('active');
                $('.s-agenda-steps__result.active').removeClass('active').prev('.s-agenda-steps__result').addClass('active');
                $('html, body').animate({
                    scrollTop: $('#agendaStepsContent').offset().top - 90
                }, 500);
            }
        })
    }


    function agendaToolsTabControl() {
        $('.s-agenda-steps__tools-tab').on('click', function () {
            let curId = $(this).attr('data-tab-id');
            $('.s-agenda-steps__tools-tab').each(function () {
                $(this).removeClass('active');
            });
            $(this).addClass('active');


            $('.s-agenda-steps__tabs-results-wrap').each(function () {
                $(this).removeClass('active');
                if ($(this).attr('id') == curId) {
                    $(this).addClass('active');
                }
            })
        })
    }

    function controlEmptyCheckboxes() {
        let fullLength = 0;
        $('.s-agenda-steps__topic-item .collapsible-body').each(function () {
            $(this).find('.topics-checkbox').each(function () {
                fullLength++;
            });


            if (!fullLength) {
                $('.main-topic-checkbox').each(function() {
                    $(this).on('click', function () {
                        if($(this).attr('required') === 'required') return;

                        if ($(this)[0].checked) {
                            $(this).closest('.s-agenda__main-checkbox-wrap').removeClass('no-check').addClass('full-check')
                        } else {
                            $(this).closest('.s-agenda__main-checkbox-wrap').removeClass('full-check').addClass('no-check')
                        }
                    })
                })
            }

            fullLength = 0;
        })


    }

    $('.main-topic-checkbox').each(function () {
        if($(this).attr('required')) {
            $(this).closest('.s-agenda__main-checkbox-wrap').removeClass('no-check').addClass('full-check');
        }
    });


    function countHours() {
        let topicHours = 0;
        let checkedLength = 0;
        let fullLength = 0;
        allHours = 0;
        $('.s-agenda-steps__topic-item .collapsible-body').each(function () {
            $(this).find('.topics-checkbox').each(function () {
                if($(this).attr('required')) {
                    $(this).attr('checked', 'checked')
                }

                if ($(this).is(':checked') || $(this).attr('required')) {
                    topicHours += parseFloat($(this).attr('data-time'));
                    checkedLength++;
                }
                fullLength++;
            });
            if ($('#agendaStepsContent').hasClass('check-hours-validation')) {
                $(this).prev('.collapsible-header').find('.s-agenda__hours').text(topicHours + 'h');
            }

            allHours += topicHours;
            if (fullLength) {
                $(this).closest('.s-agenda-steps__topic-item').find('.s-agenda__main-checkbox-wrap').removeClass('no-check').removeClass('half-check').removeClass('full-check');
                if (checkedLength == 0) {
                    $(this).closest('.s-agenda-steps__topic-item').find('.s-agenda__main-checkbox-wrap').addClass('no-check')
                } else if (checkedLength != 0 && checkedLength < fullLength) {
                    $(this).closest('.s-agenda-steps__topic-item').find('.s-agenda__main-checkbox-wrap').addClass('half-check')
                } else if (checkedLength != 0 && checkedLength == fullLength) {
                    $(this).closest('.s-agenda-steps__topic-item').find('.s-agenda__main-checkbox-wrap').addClass('full-check')
                }
            }

            fullLength = 0;
            checkedLength = 0;
            topicHours = 0;
        });
        if ($('#agendaStepsContent').hasClass('check-hours-validation')) {
            $('.s-agenda__validation-hours .hours').text(allHours.toFixed(2) + 'h')
        }
    }
});
},{}]},{},[1])